// Ice Frost Super Theme - Frozen winter / ice queen aesthetic
const iceFrost = {
    id: "iceFrost",
    name: "Jääkuningatar ❄️",
    price: 150,
    main: "#6366f1",
    light: "#a5b4fc",
    dark: "#4338ca",
    bg: "#eef2ff",
    darkBg: "#1e1b4b",
    contrastText: "#ffffff",
    isSuper: true,
    isDarkTheme: false,
    shape: "rounded",
    surfaces: {
        // Light mode
        lightBg: '#e0e7ff',
        lightPaper: '#eef2ff',
        lightContainer: '#eef2ff',
        lightOnSurface: '#1e1b4b',
        lightOnSurfaceVariant: '#4338ca',
        lightOutline: '#6366f1',
        // Dark mode
        containerLowest: '#1e1b4b',
        containerLow: '#0f0d30',
        container: '#1e1b4b',
        containerHigh: '#2d2b5c',
        containerHighest: '#3c396d',
        bright: '#4b487e',
        onSurface: '#e0e7ff',
        onSurfaceVariant: '#a5b4fc',
        outline: '#6366f1',
        outlineVariant: '#3730a3',
        // Button colors — primary
        primaryContainer: '#5e61ec',
        onPrimaryContainer: '#ffffff',
        // Button colors — secondary (outlined)
        secondaryContainer: '#2d2b5c',
        onSecondaryContainer: '#a5b4fc',
        // Button colors — secondary (filled)
        secondary: '#a5b4fc',
        onSecondary: '#1e1b4b',
        secondaryLight: '#4338ca',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#eef2ff',
        onInverseSurface: '#1e1b4b',
        inverseSurfaceLight: '#1e1b4b',
        onInverseSurfaceLight: '#e0e7ff',
        // Button colors — label/text
        labelColor: '#a5b4fc',
        labelColorLight: '#4338ca',
        // Status colors
        success: '#4caf50',
        successLight: '#81c784',
        successDark: '#2e7d32',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    typography: {
        headline: '"Inter", sans-serif',
        body: '"Inter", sans-serif',
    },
    animations: {
        avatar: "glowPulse",
        taskComplete: "profileEffect",
        completionGlow: true,
        buttonHover: "shimmer",
        cardHover: null,
        profileEffect: {
            src: "/uploads/profile-effects/arctic-frost/effect.json",
            width: 450,
            height: 880,
            scaleToCard: true,
        },
    },
    nameplate: {
        light: {
            src: "/uploads/profile-effects/arctic-winter-frost/bg.json",
            animateFirst: true,
        },
        dark: {
            src: "/uploads/profile-effects/aurora-winter-fox/bg.json",
            animateFirst: true,
        },
    },
    effects: {
        glowColor: "#a5b4fc40",
    },
    modes: {
        light: {
            background: "linear-gradient(180deg, #eef2ff 0%, #e0e7ff 40%, #c7d2fe 100%)",
            cardBg: "rgba(255, 255, 255, 0.85)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            coinCompletedBg: "#6366f1",
            coinCompletedText: "#ffffff",
            coinPendingBg: "rgba(99, 102, 241, 0.6)",
            coinPendingText: "#ffffff",
            nameColor: "#3730a3",
        },
        dark: {
            background: "linear-gradient(180deg, #1e1b4b 0%, #2d2b5c 50%, #1a1a3e 100%)",
            cardBg: "rgba(99, 102, 241, 0.15)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            coinCompletedBg: "#6366f1",
            coinCompletedText: "#ffffff",
            coinPendingBg: "rgba(99, 102, 241, 0.6)",
            coinPendingText: "#ffffff",
        },
    },
    components: {
        card: {
            borderRadius: "16px",
            border: "1px solid rgba(99, 102, 241, 0.15)",
        },
        button: { borderRadius: "16px" },
        chip: { borderRadius: "8px" },
        weeklyGoalCard: { borderRadius: "12px" },
        progressBar: { borderRadius: 50 },
    },
};

export default iceFrost;
